/* eslint-disable import/no-cycle */
import React from 'react';
import Listing from '../../pageParts/createListing/createListing';
import style from './createListingPage.module.scss';
import { CreatrListinPageInterface } from './CreateListingPageTypes';
import { category, cities } from '../../constants/constants';

const CreateListingPage: React.FC<CreatrListinPageInterface> = () => (
  <div className={style.createListingPageStyle}>
    <Listing editData={null} category={category} city={cities} />
  </div>
);

export default CreateListingPage;
